(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mega-menu-brands"] && !Shopify.designMode) return;
  try {
    
  // All behaviour is delegated on document because the header JS clones
  // this template's content into the dropdown/drawer, and cloned inline
  // scripts never run. Bound once per page load.
  if (!window.__bxMenuBound) {
    window.__bxMenuBound = true;

    var bxActivate = function (brand) {
      var bx = brand.closest('.bx');
      if (!bx) return;
      bx.querySelectorAll('.bx__brand.active').forEach(function (b) {
        if (b !== brand) b.classList.remove('active');
      });
      brand.classList.add('active');
    };

    // Desktop: sticky pane switching with a short hover-intent delay so
    // sweeping the pointer across the rail does not thrash the pane.
    var bxTimer = null;
    document.addEventListener('mouseover', function (e) {
      if (window.innerWidth < 1200) return;
      var head = e.target.closest('.bx__head');
      if (!head) return;
      var brand = head.closest('.bx__brand');
      if (!brand) return;
      clearTimeout(bxTimer);
      bxTimer = setTimeout(function () { bxActivate(brand); }, 120);
    });
    document.addEventListener('mouseout', function (e) {
      if (e.target.closest('.bx__head')) clearTimeout(bxTimer);
    });
    // Keyboard: tabbing into a brand activates its pane.
    document.addEventListener('focusin', function (e) {
      if (window.innerWidth < 1200) return;
      var brand = e.target.closest('.bx__brand');
      if (brand) bxActivate(brand);
    });

    // Mobile drawer: drill-in (Syte 2026-09-02, replaces the accordion).
    // Tapping a brand row slides its panel in over the brands list; the
    // panel's own back row slides it out again. .open marks the brand,
    // .bx-open on the drawer's scroll container fades the list behind.
    document.addEventListener('click', function (e) {
      if (window.innerWidth >= 1200) return;
      var back = e.target.closest('.bx__panel-back');
      if (back) {
        var openBrand = back.closest('.bx__brand');
        if (openBrand) openBrand.classList.remove('open');
        var backPanel = back.closest('.mnav__panel--child');
        if (backPanel) backPanel.classList.remove('bx-open');
        return;
      }
      var head = e.target.closest('.bx__head');
      if (head && head.closest('.bx')) {
        e.preventDefault();
        var brand = head.closest('.bx__brand');
        brand.classList.add('open');
        var panelChild = head.closest('.mnav__panel--child');
        if (panelChild) {
          panelChild.classList.add('bx-open');
          panelChild.scrollTop = 0;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
